import React from 'react';
import { connect } from 'react-redux';
import { setActiveTab } from '../actions/actions';
import { Container } from '@material-ui/core';
import styled from 'styled-components';
import RevenueImage from '../assets/revenue.png'
import RevenueActiveImage from '../assets/revenue_active.png'
import ResultsImage from '../assets/results.png'
import ResultsActiveImage from '../assets/results_active.png'
import MerchandiseCostImage from '../assets/merchandise.png'
import MerchandiseCostActiveImage from '../assets/merchandise_active.png'
import FixedCostsImage from '../assets/fixed_costs.png'
import FixedCostsActiveImage from '../assets/fixed_costs_active.png'
import VariableCostsImage from '../assets/variable_costs.png'
import VariableCostsActiveImage from '../assets/variable_costs_active.png'




const IconBarContainer = styled(Container)`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-column-start: 1;
  grid-column-end: 4;
  background-color: white;
`;

const IconContainer = styled.div`
  display: grid;
  border-bottom: 1px solid #8080803d;
  &:last-child {
    border-right: 0px !important;
  };
  border-right: 1px solid #8080803d;
`

const IconContainerActive = styled.div`
  display: grid;
  border-bottom: 1px solid #8080803d;
  &:last-child {
    border-right: 0px !important;
  };
  background-color: #e45306;
  border-right: 1px solid #8080803d;
`

const Icon = styled.img`
  margin: 12px;
  padding: 8px;
  @media (max-width: 768 px) {
    margin: 0px !important;
  }
  @media (max-width:320px) { 
    width: 30px;
    margin: 0px !important;
  }
  @media (min-width:321px) and (max-width: 480px) {
    width: 35px;
    margin: 0px !important;
  };
  @media (min-width: 481px) {
    width: 45px;
  };
  place-self: center;
`;


function IconBar(props) {

  return (
    <IconBarContainer disableGutters>
      {props.activeTab === 1 ? <IconContainerActive><Icon src={RevenueActiveImage}></Icon></IconContainerActive> : <IconContainer><Icon src={RevenueImage}></Icon></IconContainer> }
      {props.activeTab === 2 ? <IconContainerActive><Icon src={VariableCostsActiveImage}></Icon></IconContainerActive> : <IconContainer><Icon src={VariableCostsImage}></Icon></IconContainer> }
      {props.activeTab === 3 ? <IconContainerActive><Icon src={FixedCostsActiveImage}></Icon></IconContainerActive> : <IconContainer><Icon src={FixedCostsImage}></Icon></IconContainer> }
      {props.activeTab === 4 ? <IconContainerActive><Icon src={MerchandiseCostActiveImage}></Icon></IconContainerActive> : <IconContainer><Icon src={MerchandiseCostImage}></Icon></IconContainer> }
      {props.activeTab === 5 ? <IconContainerActive><Icon src={ResultsActiveImage}></Icon></IconContainerActive> : <IconContainer><Icon src={ResultsImage}></Icon></IconContainer> }
    </IconBarContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    activeTab: state.reducers.activeTab
  }
}

const mapDispatchToProps = { setActiveTab }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconBar)
